exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);", ""]);

// module
exports.push([module.id, "._1w6WP {\n  font-family: 'Inter', 'Helvetica Neue', Arial, sans-serif;\n  color: #1a1a1a;\n  line-height: 1.6;\n  overflow-x: hidden;\n}\n", ""]);

// exports
exports.locals = {
	"homepage": "_1w6WP"
};